import { useTranslation } from "react-i18next";
import { Button } from "@heroui/react";
import { useSession } from "@/services/auth";

export function SessionRecovery() {
  const { t } = useTranslation("app");
  const { login } = useSession();
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div role="alert" className="max-w-md space-y-4 text-center">
        <h1 className="text-xl font-semibold">{t("sessionRecovery.title")}</h1>
        <p className="text-default-600">{t("sessionRecovery.description")}</p>
        <Button color="primary" onPress={login}>
          {t("sessionRecovery.signIn")}
        </Button>
      </div>
    </div>
  );
}
